import axios from 'axios';
import { tools } from '@/assets/js/tools'
import signMd5Utils from '@/assets/js/signMd5Utils'
import "../plugins/vue2-toast";

let http = axios.create({
  timeout: 5000
})

//请求拦截
http.interceptors.request.use(
  config => {
    const uuid = tools.uuid()
    const sign = signMd5Utils.getSign(uuid)
    config.headers["x-auth-uu"] = uuid
    //请求id(用于后端调试)
    const requertIdUuid = tools.uuid()
    config.headers['x-request-id'] = requertIdUuid
    config.headers["x-auth-sign"] = sign
    return config;
  },
  error => {
    Promise.reject(error);
  }
)

//响应拦截
http.interceptors.response.use(
  response => {
    let res = response.data;
    const getMsg = () => `${res.msg}${res.requestId ? '[' + res.requestId.slice(-6) + ']' : ''}`
    if (res.code == "12200") {//请求成功时
      return Promise.resolve(res);
    } else {
      switch (parseInt(res.code)) {
        case 40002:
          if (res.data.msg != '不弹提示框') {
            window.$app.$toast(getMsg())
          }
          return Promise.resolve(res.data)

        default:
            if (res.code != 21308 && res.code != 400000) {
              window.$app.$toast(getMsg() || res.msg)
            }
          return Promise.resolve(res.data)
      }
    }
  },
  error => {
    return Promise.reject(error);
  }
)

export default http;